import React from 'react'
import PropTypes from 'prop-types'
import { makeStyles } from '@mui/styles'

import { FONT_SIZES } from '@/theme'
import AppBase from './app-base'

const AppCard = ({
  name,
  icon,
  developerId,
  summary,
  className,
  href,
  onClick,
}) => {
  const classes = useStyles()

  return (
    <AppBase
      onClick={onClick}
      href={href}
      icon={icon}
      className={className}
      name={name}
      developerId={developerId}
    >
      <div className={classes.summary}>{summary}</div>
    </AppBase>
  )
}

const useStyles = makeStyles(theme => ({
  summary: {
    overflowWrap: 'break-word',
    display: '-webkit-box',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    '-webkit-line-clamp': 6, // number of lines to show
    '-webkit-box-orient': 'vertical',
    color: theme.textColor,
    fontSize: FONT_SIZES.smaller,
  },
}))

AppCard.propTypes = {
  name: PropTypes.string,
  icon: PropTypes.string,
  summary: PropTypes.string,
  className: PropTypes.string,
  href: PropTypes.string.isRequired,
}

AppCard.defaultProps = {
  name: '',
  icon: '',
  summary: '',
  className: null,
  href: '#',
}

export default AppCard
